import preval from 'preval.macro';

export const buildDate = preval`module.exports = (new Date()).toISOString().split('.')[0].replace('T',' ');`;
export const buildVersion = buildDate.replace(
  /\d\d(\d\d)-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)/,
  '$2$3.$4$5'
);
